import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Loyaltic } from 'src/app/core/helpers/api-url.constants';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isShowLogin = true;
  isShowForgotPassword = false;
  email: any;
  password: any;
  errorMessage = '';
  isLoggedIn = false;

  constructor(private coreService: CoreService, private authService: AuthService,public gaService: GaService,
    private translate: TranslateService, private toast: ToastrService, private router: Router, private location: Location) { }

  ngOnInit() {
  }

  showLogin(){
    this.isShowForgotPassword = true;
    this.isShowForgotPassword = false;
    this.isShowLogin = true;
  }
  showForgotPassword(){
    this.isShowForgotPassword = true;
    this.isShowLogin = false;
  }

  onSubmit(form) {
    this.errorMessage = '';
    this.coreService.logIn({ Email: this.email, Password: this.password }).then((response: any) => {
      if (response.messageKey === 'Success') {
        localStorage.setItem("email", this.email);
        this.gaService.emitEvent('login_username', 'login screen');
        this.authService.setToken(response.result.token, response.result.id);
        const successMessage = this.translate.instant(response.messageKey);
        this.toast.success(successMessage, '');
        this.isLoggedIn = true;
      //   this.router.navigateByUrl('app', { skipLocationChange: true }).then((e) => {
      //     console.log(e);
      //     if(e){
      //       this.router.navigate(['']);
      //     }
      // });
      // this.router.navigate(['*'], { queryParams: {login: 'success'}, skipLocationChange: false});
        this.router.navigate([this.getHomePath()]);
      } else {
        this.errorMessage = response.messageKey;
        this.toast.error(this.errorMessage, '');
      }
    }).catch((errorResponse: any) => {
      // if (errorResponse.error.messageKey === 'error-invalid-credentials') {
      this.errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(this.errorMessage, '');
      // }
    });
  }

  private getHomePath(): string {
    const firstSegment = this.router.url.split('?')[0].split('#')[0].split('/').filter(Boolean)[0];

    if (firstSegment === 'se' || firstSegment === 'fi') {
      return '/' + firstSegment;
    }

    return '/';
  }
}
